import React from 'react';
import Heading from '../../../generic-components/Heading';
import { ProfilePlanPromotion } from '../../profile/components/ProfilePlanPromotion';
import { report } from '../../../assets/svg';
import { useStore } from '../../../store';
import Icon from '../../../generic-components/Icon';
import { CustomerProfile } from '../../../components/CustomerProfile/CustomerProfile';

export const UpgradeIntro = () => {
  const summaryData = useStore((state) => state.summary);
  return (
    <div className='bg-bw02 h-screen pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[6rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col fadeIn'>
      <div className='flex flex-col h-full fadeIn bg-bw00 rounded-[8px]'>
        <CustomerProfile />
        <Heading
          title='Expense Reports'
          className='py-[16px] px-[24px] border-b border-b-bw03 font-metricRMedium text-[20px] text-bw08'
        />
        <div className='flex flex-col w-full h-full items-center justify-center'>
          <Icon className='w-[109px] h-[109px]' src={report} />
          <Heading
            title='Upgrade Now to generate your Expense Report'
            className='font-metricRMedium text-[24px] text-bw08 mb-[14px]'
          />
          <Heading
            title='Create your Expense Report to keep track of your expenses'
            className='font-metricR text-[16px] w-[450px] text-center text-bw07 mb-[30px]'
          />
          <ProfilePlanPromotion
            customTitle='Upgrade Now'
            planType={summaryData.customerProfileInfo.customerProfile}
            shouldAppearAsButton
          />
        </div>
      </div>
    </div>
  );
};
